import axiosClient from "../api/axiosClient";
import { getRequest, postRequest } from "../api/request";

export const getWhatsAppReports = (params) => {
  return getRequest("/whatsapp/report", params);
};

export const sendWhatsReport = (reportId) => {
  return postRequest(`/whatsapp/send/${reportId}`);
};

// Search customers by name/phone/serial
export const searchCustomers = async (query) => {
  return await getRequest(`/customers/search/query?q=${query}`);
};

// Get PDF URL for a report
export const getReportPdf = async (reportId) => {
  return await axiosClient.get(`/whatsapp/pdf/view/${reportId}`, {
    responseType: "blob",
  });
};
